import Titlebar from "../layout/titlebar";
import Lang from "../../userPreferences/staticWords";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import {
  clearAllWorkTeamsAPI,
  getAllWorkTeamsAPI,
} from "../../API/store/actions/workteams/workteams";
import { paths } from "../../paths/paths";
import { Link, useNavigate } from "react-router-dom";
import { styleStart } from "../../algorithms/styleDirection";
import LoadingPopup from "../layout/loadingPopup";
import Button from "../sharedComponents/buttons/button";
import { addMessageRoom, alreadyHaveARoom } from "../../API/store/actions/auth";
import { objToFormData, ScrollToTop } from "../../algorithms";
import { resolver } from "../../API/middlewares/resolveRequests";
import BackIcon from "../BackIcon/BackIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen } from "@fortawesome/free-solid-svg-icons";
import UsersAlerts from "../admin/userManage/userAlerts";
const WorkTeam = () => {
  const dispatch = useDispatch();
  const allWorkTeams = useSelector((state) => state.workTeams.getAllWorkTeams);
  const communityId = 0; //useSelector((state) => state.community.communityId?.id);
  const userLogged = useSelector((state) => state.login.userData);
  const userToken = useSelector((state) => state.login.userToken);
  const [reload, setReload] = useState(false);
  useEffect(() => {
    dispatch(getAllWorkTeamsAPI(communityId, 1, 100, userToken));
    ScrollToTop();

    return () => {
      dispatch(clearAllWorkTeamsAPI());
    };
  }, [communityId, userToken, reload]);
  const [item, setItem] = useState(null);
  const [search, setSearch] = useState("");
  const filteredData = useMemo(() => {
    return (
      allWorkTeams?.data?.filter((item) =>
        item.memberName?.toLowerCase().includes(search.trim().toLowerCase()),
      ) || []
    );
  }, [allWorkTeams, search]);
  const isLoading = !allWorkTeams || allWorkTeams.loading;
  const isEmpty = filteredData.length === 0;
  const navigator = useNavigate();
  const [isRoom, setIsRoom] = useState({});
  const [modalVisible, setModalVisible] = useState({
    addUserData: false,
    ediUser: false,
    helperData: null,
  });
  useEffect(() => {
    if (item)
      resolver(
        alreadyHaveARoom,
        setIsRoom,
        userLogged?.memberId,
        item,
        userToken,
      );
  }, [item]);

  useEffect(() => {
    if (isRoom?.data)
      if (isRoom?.data?.status == true) {
        navigator(`/profile/${isRoom.data.roomId}`);
      } else if (isRoom?.data?.status == false) {
        let res = addMessageRoom(
          objToFormData({
            SenderId: userLogged?.memberId,
            RecieverId: item?.memberId,
          }),
          userToken,
        );
        if (res.status <= 206) {
          navigator(`/profile/${res?.data?.id}`);
        }
      }
  }, [isRoom?.data]);
  if (isLoading) {
    return <LoadingPopup show={true} />;
  }
  return (
    <div className="d-flex flex-column w-100 px-3">
      <div
        className="ctr"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "0 20px",
          position: "relative",
          zIndex: "10",
        }}
      >
        <BackIcon />
      </div>
      <Titlebar
        title={Lang.workTeam}
        customImage={"/assets/images/icon3.svg"}
      />
      {/* search */}
      <div className="d-flex justify-items-center gap-2 my-3 px-3">
        <input
          type="text"
          placeholder={Lang.searchByName}
          className="form-control w-[90%]!important"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="back-icon-btn">
          <button
            onClick={() =>
              setModalVisible((prev) => ({
                ...prev,
                addUserData: true,
              }))
            }
            className="h-100"
          >
            {Lang.addMember}
          </button>
        </div>
      </div>
      <UsersAlerts
        userToken={userToken}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        onSuccess={() => setReload((prev) => !prev)}
      />
      {/* table */}
      <div className="d-flex align-items-center">
        <div className="d-flex flex-column w-100 px-3 report_table">
          <table className="">
            <thead>
              <tr>
                <th style={{ width: "90%" }}>الاسم</th>
                {/* <th>المرفقات</th> */}
                <th>{Lang.operations}</th>
              </tr>
            </thead>

            <tbody>
              {isEmpty ? (
                <tr>
                  <td
                    colSpan="2"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    {Lang.noData}
                  </td>
                </tr>
              ) : (
                filteredData.map((item) => {
                  const userPhoto = item.memberPhoto
                    ? `/assets/images/org.svg`
                    : `/assets/images/org.svg`;

                  return (
                    <tr key={item.memberId}>
                      <td style={{ width: "90%" }}>
                        <div className="d-flex align-items-center gap-2 mx-3">
                          {/* <img
                            src={userPhoto}
                            width={40}
                            height={40}
                            style={{ borderRadius: "50%" }}
                          /> */}
                          <div>{item.memberName}</div>
                        </div>
                      </td>

                      {/* <td>
                        {item?.attchment?.length
                          ? item.attchment.map((file, i) => (
                              <a
                                key={i}
                                href={`${paths.MemberAttach}${item.memberId}/${file}`}
                                target="_blank"
                                rel="noreferrer"
                                className="mx-2"
                              >
                                file
                              </a>
                            ))
                          : "لا يوجد"}
                      </td> */}
                      <td className="mx-auto">
                        <div className="d-flex  justify-content-center align-items-center gap-4">
                          {/* view */}
                          <div>
                            <Link
                              to={`/tasks/${item.memberId + "&" + item.memberName}`}
                              title={Lang.view}
                              className="text-dark"
                            >
                              <FontAwesomeIcon icon={faEye} />
                            </Link>
                          </div>

                          {/* edit */}
                          <div>
                            <button
                              type="button"
                              className="border-0 bg-transparent"
                              title={Lang.edit}
                              onClick={() =>
                                setModalVisible((prev) => ({
                                  ...prev,
                                  ediUser: true,
                                  helperData: {
                                    id: item.userId,
                                  },
                                }))
                              }
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WorkTeam;
